export default __webpack_public_path__ + "static/media/whatsapp.acd8e702.svg";